import { Chip } from '@/design-system/ui'

export default function GoGoPoolNotice({ compact = false }: { compact?: boolean }) {
  return (
    <div
      className={compact ? 'p-4' : 'lg:p-6 p-5'}
      style={{ background: 'var(--warn-wash)', borderRadius: 16 }}
    >
      <Chip dot tone="warn">
        GoGoPool is winding down
      </Chip>
      <p
        className="mt-3"
        style={{ color: 'var(--body)', fontSize: compact ? 13 : 14, lineHeight: 1.55 }}
      >
        New GGP deposits are closed. You can still withdraw your GGP at any time.{' '}
        <a
          className="underline"
          href="https://eol.gogopool.com/"
          rel="noopener noreferrer"
          style={{ color: 'var(--warn)', fontWeight: 500, textUnderlineOffset: 2 }}
          target="_blank"
        >
          Read the wind-down notice ↗
        </a>
      </p>
    </div>
  )
}
